
<div class="row">
    <div class="col-sm-12">
      <h3 class="sub-title alert alert-info">Activity Types</h3></div>
    <div class="col-sm-12 text-end alert">
        <a [routerLink]="['/admin/activity/types/new']" class ="btn btn-primary"> <i class="fa fa-plus"></i> Add Activity Type</a>
    </div>
  </div>
<div class="table-responsive" *ngIf="activityTypeList.length>0">
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>

    <th>Name</th>

    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let activityType of activityTypeList;">

        <td>{{activityType.name}}</td>

    </tr>

    </tbody>

</table>
</div>
<app-spinner *ngIf="(activityTypeList.length==0) && loading"></app-spinner>
<div *ngIf="(activityTypeList.length==0) && !loading" class="text-center">No Records Found </div>

